<script>
    import { createEventDispatcher } from "svelte";
    import { set_input_value } from "svelte/internal";
    import { numberFormatStore } from "../store/numberFormat.js";

    const dispatch = createEventDispatcher();
    export let value;
    export let error = false;
    export let id = "";
    export let readonly = false;
    if (value == null) value = 0;
    $: valueinternal = roundToTwo(value * 100);
    function roundToTwo(num) {
        return +(Math.round(num * 1 + "e+6") + "e-6") / 1;
    }
    function bubble(type) {
        try {
            dispatch(type);
        } catch (s) {}
    }
    let timer;
    function bubbleDebounced(type) {
        clearTimeout(timer);
        timer = setTimeout(async () => {
            bubble(type);
        }, 50);
    }

    function setValue(valueinternal) {
        if (value != roundToTwo(valueinternal / 100)) {
            value = roundToTwo(valueinternal / 100);
        }
    }
</script>

<span class="prelabel percentage">%</span>
{#if readonly}
    <input
        type="number"
        class="prelabel--has"
        {id}
        value={valueinternal}
        readonly
        class:readonly
        class:alert={error}
    />
{:else}
    <input
        type="number"
        class="prelabel--has"
        {id}
        on:keyup={() => {
            bubble("keyup");
        }}
        on:keydown={() => {
            bubble("keydown");
        }}
        on:change={() => {
            bubble("change");
        }}
        on:focusout={() => {
            bubble("focusout");
        }}
        on:focusin={() => {
            bubble("focusin");
        }}
        on:focus={(e) => {
            e.target.select();
        }}
        on:change={setValue(valueinternal)}
        bind:value={valueinternal}
        {readonly}
        class:alert={error}
        class:readonly
    />
{/if}
